module.exports = __webpack_public_path__ + "static/media/background.40b10126.jpg";